import { removeCookie } from '@util/cookie';
import { removeGrayItem } from '@util/handleGrayByLocalstorage';
/**
 * 灰度名单
 * {
 *   testKey: 灰度testKey,
 *   name: cookie名或ls名，默认为testKey,
 *   value： cookie值或ls名，默认'Y',
 *   location: 存放位置，cookie或者localstorage
 *   forceReload: 是否强制页面刷新
 *   otherName: 当前需求需要获取埋入其他key
 *   http://octo.test.sankuai.com/serverOpt/operation?appkey=com.sankuai.sjst.erp.abtest#config
 * }
 * @type {*[]}
 */
export const grayList = [
  {
    testKey: 'pingxin_fe_account_verifyPhoneAndCode',
    location: 'localstorage',
    forceReload: true,
  },
  {
    testKey: 'pingxin_fe_account_rms',
    location: 'localstorage',
    forceReload: true,
  },
  {
    testKey: 'pingxin_fe_account-web_logo',//component-web中依赖该cookie，请联系lixiaochen03
    location: 'cookie',
    forceReload: false,
  },
  {
    testKey: 'pingxin_fe_find_pwd',//修改忘记密码的路由跳转
    location: 'cookie',
    forceReload: false,
  },
  {
    testKey: 'pingxin_hq_irs_login_session_userid',//配合后端做session会话统一
    location: 'cookie',
    forceReload: false,
  },
  {
    testKey: 'pingxin_fe_account-web_no-touch-order',
    location: 'localstorage',
    forceReload: false,
  },
  {
    testKey: 'pingxin_fe_account-web_risk',
    location: 'localstorage',
    forceReload: true,
  },
  {
    testKey: 'pingxin_fe_irs-static_emergency-msg', // 用于设置紧急公告是否强制阅读的灰度key
    location: 'localstorage',
    forceReload: false,
  }
];
const cookiesToBeRemoved = [
  'fe-register-poi',
  'scm-strategy-helpcenter',
  'scmmain-strategy-helpcenter',
  'pingxin_fe_custom_service_v2',
  'pingxin_fe_component-web_help-center',
  'pingxin_fe_lx_tracker', // 云端埋点
];
cookiesToBeRemoved.forEach(item => {
  removeCookie(item);
});
const lsToBeRemoved = ['pingxin_mobile_belong_id', 'pingxin_fe_find_pwd_url', 'pingxin_fe_verify_code', 'pingxin_fe_account_MTMap'];
lsToBeRemoved.forEach(item => {
  removeGrayItem(item);
});



// WEBPACK FOOTER //
// ./src/constants/gray.js